import { Button } from "./Button";
import { Link } from "./Link";
export var components = {
  Button,
  Link
};
//# sourceMappingURL=components.js.map